module.exports = __webpack_public_path__ + "img/experience-logo.10b62412.svg";